export function pureStructureFrom(structure: unknown) {
  if (!structure) {
    return structure;
  }

  if (structure === Infinity) {
    return Infinity;
  }

  return JSON.parse(JSON.stringify(structure));
}
